import featureFlag from '@/api/featureFlag';
import Segment from '@/Segment';
import TourApi from '../../api/TourApi';

const state = {
  hasTourPending: false,
};

const actions = {
  async init({ commit, dispatch }) {
    const { hasTourPending } = await TourApi.fetchCashflowTourPending();
    const shouldHideTour = (await featureFlag.getTreatment('elsa_hide_onboarding_tour')) === 'on';
    if (shouldHideTour && hasTourPending) {
      Segment.trackUserGot('TourSkipped');
      dispatch('markAsDone');
    } else {
      commit('setHasTourPending', hasTourPending);
    }
  },
  async markAsDone({ commit }) {
    await TourApi.markAsDone();
    commit('setHasTourPending', false);
  },
};

// mutations
const mutations = {
  setHasTourPending(state, hasTourPending) {
    state.hasTourPending = hasTourPending;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
